const resetDefaultState = () => {
	return {
		errorDialog: false,
		errorDialogMessage:"",
		errorStatusCode:""
	}
};

export default {
	namespaced: true,
	state:{
		errorDialog: false,
		errorDialogMessage: "",
		errorStatusCode: "",
		errorBtnText: "OK",
		isOrganizationExpired:false,
		organizationExpiredMessage:"",
	},
	mutations:{
		setErrorDialogStatus(state,status){
			state.errorDialog = status;
		},

		setErrorDialogMessage(state,msg){
			state.errorDialogMessage = msg;
		},

		setErrorStatusCode(state, code){
			state.errorStatusCode = code;
		},

		setErrorBtnText(state, text){
			state.errorBtnText = text;
		},

		setErrorDialogDefaultState(state){
			Object.assign(state, resetDefaultState())
		},

		setOrganizationExpiredStatus(state, status){
			state.isOrganizationExpired = status;
		},

		setOrganizationExpiredMessage(state, msg){
			state.organizationExpiredMessage = msg;
		}
	}
}
